// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\home\\\\StudioTypesSection\\\\StudioTypesSection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\home\\StudioTypesSection\\StudioTypesSection.tsx");
  import.meta.hot.lastModified = "1757171103317.1108";
}
// REMIX HMR END

import { StudiosSection } from "./components/StudiosSection";
const studioTypes = [{
  id: "1",
  image: "/images/home/studios/video-studios.png",
  title: "VIDEO STUDIOS",
  description: "Whether you're filming, livestreaming, or editing, our video studios are built for every stage of production.",
  href: "/studios/video"
}, {
  id: "2",
  image: "/images/home/studios/music-studios.png",
  title: "MUSIC STUDIOS",
  description: "Spaces to make your music heard. Treated rooms, pro interfaces, and backline on request.",
  href: "/studios/music"
}, {
  id: "3",
  image: "/images/home/studios/photo-studios.png",
  title: "PHOTO STUDIOS",
  description: "Our photography studios are equipped for everything from product shoots to portrait sessions.",
  href: "/studios/photo"
}];
export function StudioTypesSection() {
  return <StudiosSection title="STUDIOS TAILORED TO YOUR NEEDS" subtitle="Our studios are designed with versatility in mind, providing flexible spaces that adapt to any creative pursuit." items={studioTypes} isCarousel={true} />;
}
_c = StudioTypesSection;
var _c;
$RefreshReg$(_c, "StudioTypesSection");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;